import PropTypes from 'prop-types'
import React from 'react'
import { FieldArray } from 'redux-form'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import withTranslation from 'next-translate/withTranslation'
import { getUserInfo } from '../../../../../selectors'
import { WorkingTime } from '../WorkingTime'
import { AddAddressBtn } from '../AddAddressBtn'
import { RemoveAddressBtn } from '../RemoveAddressBtn'
import { Header } from '../../Header'
import { Address } from '../Address'
import config from 'SRC/config/config.json'

export class Container extends React.Component {
  isBusinessUser = () => this.props.type && this.props.type !== config.userTypes.freeUserTypeSeo

  getHeader = () => {
    const { i18n: { t } } = this.props

    return this.isBusinessUser() ? t('common:Adresa (Glavna)') : t('common:Adresa stanovanja')
  }

  getMainAddressIndex = () => {
    if (this.props.userAddresses.length) {
      const mainIndex = this.props.userAddresses.findIndex(item => Boolean(item.main))
      if (mainIndex > -1) {
        return mainIndex
      }
      return 0
    }
    return -1
  }

  renderAddresses = ({fields, mainIndex}) => {
    const { i18n: { t } } = this.props

    return [
      fields.map((item, index) =>
        index < this.props.maxAddressesCount && index !== mainIndex
          ? [
            <Header key={`header-${item}`}>{t('common:Adresa (Dodatna)')}</Header>,
            <Address key={`address-${item}`} index={index} isBusiness />,
            <WorkingTime key={`workingTime-${item}`} index={index} />,
            <RemoveAddressBtn onClick={() => fields.remove(index)} key={`removeBtn-${index}`} />
          ]
          : null
      ),
      fields.length < this.props.maxAddressesCount
        ? <AddAddressBtn onClick={() => fields.push()} key='addAddressBtn' />
        : null
    ]
  }

  render () {
    const mainIndex = this.getMainAddressIndex()
    const isBusinessUser = this.isBusinessUser()
    return [
      <Header key={`header-${mainIndex}`}>{this.getHeader()}</Header>,
      <Address key={`address-${mainIndex}`} index={mainIndex} isBusiness={isBusinessUser} />,
      isBusinessUser ? <WorkingTime key={`workingTime-${mainIndex}`} index={mainIndex} /> : null,
      isBusinessUser
        ? <FieldArray key='addresses' component={this.renderAddresses} name='userAddresses' mainIndex={mainIndex} />
        : null
    ]
  }
}

Container.displayName = 'Addresses'

const mapStateToProps = state => {
  const result = {type: '', maxAddressesCount: 3}
  const userInfo = getUserInfo(state)
  if (userInfo) {
    if (userInfo.type && userInfo.type.seo) {
      result.type = userInfo.type.seo
    }
    if (userInfo.userAddresses && Array.isArray(userInfo.userAddresses)) {
      result.userAddresses = [...userInfo.userAddresses]
    }
    if (userInfo.packages && Array.isArray(userInfo.packages) && userInfo.packages.length) {
      const maxAddressesCount = userInfo.packages[0].locationLimit
      if (maxAddressesCount) {
        result.maxAddressesCount = maxAddressesCount
      }
    }
  }
  return result
}

Container.propTypes = {
  type: PropTypes.string.isRequired,
  userAddresses: PropTypes.arrayOf(PropTypes.shape({
    main: PropTypes.bool,
    id: PropTypes.number.isRequired
  })),
  maxAddressesCount: PropTypes.number.isRequired
}

Container.defaultProps = {
  type: '',
  userAddresses: [],
  maxAddressesCount: 1
}

const enhance = compose(
  connect(mapStateToProps),
  withTranslation
)

export default enhance(Container)
